<template>
  <PageContent>
    <div class="level pl-2">
      <div class="level-left level-item title">{{ $t('evotingList.title') }}</div>
    </div>
    <div class="pb-1">
      <b-button
        @click.prevent="createBallotModal()"
        type="is-primary"
        size="is-small"
        rounded
        :style="{
          ...(breakpoint === 'desktop'
            ? {}
            : {
                width: '100%'
              })
        }"
      >
        Add Ballot
      </b-button>
    </div>
    <div>
      <ModernTable
        :region="region"
        :filters="filters"
        :rows="rows"
        :columns="columns"
        :pagination="{
          perPage: 12
        }"
        :loading="loading"
      />
    </div>
    <Modal :toggle.sync="toggle">
      <BallotModal :redirectToDetails="redirectToDetails" :ballot="selectedBallot"> </BallotModal>
    </Modal>
  </PageContent>
</template>

<script>
import PageContent from '@/containers/PageContent'
import ModernTable from '@/components/tables/Modern/Table'
import BallotModal from './components/ballotModal'
import Modal from '@/components/Modal'
import { mapState, mapGetters } from 'vuex'
import { methods } from './keys/methods'
import { data } from './keys/data'

export default {
  name: 'EvotingList',
  components: {
    PageContent,
    ModernTable,
    BallotModal,
    Modal
  },

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId,
      ...mapGetters('user', ['authUser']),
      breakpoint: state => (state && state.win ? state.win.breakpoint : null)
    })
  },

  data,

  methods,

  async mounted() {
    await this.reload()
  },

  watch: {
    statusFilter: 'reload',
    hoaId() {
      this.reload()
    },
    toggle() {
      if (this.toggle == false) {
        this.reload()
        this.toggle = false
        if (this.Modal && this.Modal != undefined) {
          this.Modal.$emit('update:toggle', (this.toggle = false))
        }
      }
    }
  },

  i18n: {
    messages: {
      en: {
        evotingList: {
          title: 'eVoting'
        }
      }
    }
  }
}
</script>

<style></style>
